import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonBehaviorChangeService } from './utils/common-behaviour-service';
import { lastValueFrom } from 'rxjs';
import { WsShopallService } from './ws/wsShopAll/ws-shopall.service';
import { MGetAllShopAllModuleDataResponse, MGetBrandResponse } from './pages/product/product.module';
import { WsSubHeaderService } from './ws/wsSubHeader/ws-sub-header.service';
import { MCommonListModalRequest, SharedPrefrences } from './utils/utils.service';
declare var $: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Foy';
  urlShow: any
  url: any;
  isMobile: boolean = false;
  showToast: boolean = false;
  message: any = '';
  mGetAllShopAllModuleDataResponse: MGetAllShopAllModuleDataResponse = new MGetAllShopAllModuleDataResponse();
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  mGetBrandResponse: MGetBrandResponse = new MGetBrandResponse()


  customerMenuLists: any = []
  alphabet: any = [];
  alphabets: any = [];
  alreadyProcessedIds: Set<number> = new Set();
  brandImageList: any = [];
  @HostListener('document:click', ['$event'])
  DocumentClick(event: any) {
    var brandPop = document.getElementById("brand-hover-id")
    if(brandPop){
      if($(event.target).closest("#brand-hover-id").length === 0){
        brandPop.classList.remove('active')
        document.body.style.cssText = ''
      }
    }

  }
  constructor(private wssubheaderservice: WsSubHeaderService,private router: Router, private _commonBehaviorChangeService: CommonBehaviorChangeService, private wsShopAllService: WsShopallService) {
    this._commonBehaviorChangeService.toastMessage.subscribe((message: any) => {
      if(message != null && message != false && message != 'null' &&  message != 'false' && message != ''){
        this.message = message;
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
          this.message = '';
        }, 4000);
      }
    })
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.url = evt.url;
        const urlPattern = /^\/shop-all\/?($|\?)/;
        if (this.url.indexOf('/shop-all?') === -1 && this.url != '/shop-all' && this.url.indexOf('/shop-all/') === -1 && this.url.indexOf('/individual-brand/') === -1) {
          const addOverflowClass = document.querySelectorAll('.main-wrap');
          addOverflowClass.forEach(element => {
            element.classList.add('new-main-wrap');
          });
        }
        else{
          const removeOverflowClass = document.querySelectorAll('.main-wrap');
          removeOverflowClass.forEach(element => {
            element.classList.remove('new-main-wrap');
          })
        }
      }
    });
  }
  ngOnInit(): void {
    window.addEventListener('scroll', this.scrollEvent, true);
    this.getCustomerMenuList()
    this.getAllBrand()
  }


  async getCustomerMenuList() {
    const customerMenuListData = this.wssubheaderservice.getCustomerMenuList();
    await lastValueFrom(customerMenuListData).then(response => {
      if (response && response.statusCode == 200) {
        this.customerMenuLists = response.data.categoryList;
      }
    })
  }


  /**
   * Date: 10-06-23
   * Method: This method is used to get subcategory , skintype and skin concern of selected category
   */
  async getAllModuleDataOfShopAll(categoryId: any, i: any) {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("" + categoryId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        this.customerMenuLists[i]['skinConcernList'] = this.mGetAllShopAllModuleDataResponse.data.skinConcernList;
        this.customerMenuLists[i]['skinTypeList'] = this.mGetAllShopAllModuleDataResponse.data.skinTypeList;
      } else {
      }
    })
  }

  scrollEvent = (event: any): void => {
    let sticky = window.pageYOffset;
    if (sticky > 200) {
      $(".sub-menu").addClass("sticky-submenu");
    } else {
      $(".sub-menu").removeClass("sticky-submenu");
    }
  }

  async getAllBrand() {
    this.mCommonListModalRequest.take = 1000
    this.mCommonListModalRequest.isAllowInactive = false;
    const getAllBrand = this.wsShopAllService.getAllBrand(this.mCommonListModalRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data.sort(function (a: any, b: any) {
          if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
            return -1;
          } else {
            return 0
          }
        });
       await this.mGetBrandResponse.data.forEach((brand: any) => {
          this.alphabet.forEach((alpha:any) => {
            let brandname = brand.name.toLowerCase();
            let alphaSmall = alpha.toLowerCase()
            if (brandname.startsWith(alphaSmall)) {
              if (this.alphabets.length < 1) {
                this.alphabets.push(alpha);
              } else {
                if (this.alphabets.indexOf(alpha) == -1) {
                  this.alphabets = [...this.alphabets, ...alpha]
                }
              }
            }
          })
          if (brand.imageList && brand.imageList.length > 0) {
            brand.imageList.forEach((b_image: any) => {
              b_image['name'] = brand.name
              b_image['brand_type'] = brand.brand_type;
              b_image['id'] = brand.id;
              if (b_image.type == 'brand_logo_image' && !this.alreadyProcessedIds.has(brand.id)) {
                b_image['logo_image'] = b_image.path;
                this.brandImageList.push(b_image);
                this.alreadyProcessedIds.add(brand.id);
              }
            })
          }
        })

      } else {
      }
    })
  }

}
